var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8536 5.85358L10.7072 10L14.8536 14.1464L14.1464 14.8536L10 10.7072L5.85358 14.8536L5.14642 14.1464L9.29285 10L5.14642 5.85358L5.85358 5.14642L10 9.29285L14.1464 5.14642L14.8536 5.85358ZM20 10C20 15.514 15.514 20 10 20C4.48596 20 0 15.514 0 10C0 4.48596 4.48596 0 10 0C15.514 0 20 4.48596 20 10ZM19 10C19 5.03735 14.9626 1 10 1C5.03735 1 1 5.03735 1 10C1 14.9626 5.03735 19 10 19C14.9626 19 19 14.9626 19 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXCircle);
export default __webpack_public_path__ + "static/media/icon-x-circle.bbfeaa8eb0876c3ea937f3ed2367f9b3.svg";
export { ForwardRef as ReactComponent };